import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-terminate-worker-policy-user',
	templateUrl: './modal-terminate-worker-policy-user.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputDatepickerNewComponent, FormsModule ]
})
export class ModalTerminatePolicyUserComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalTerminatePolicyUserComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'twpu-' + Date.now();
		this.vm.businessUserWorker = this.vm.providedData.businessUserWorker;
		this.vm.policy = this.vm.providedData.policy;
		this.vm.wallet = this.vm.providedData.wallet;
		this.vm.user = this.session.getSession().user;
		this.vm.isInsuranceDatePickerHidden = this.session.isInsuranceDatePickerHidden();
		var minDate;
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			minDate = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date();
		}
		
		this.vm.newTerminationDate = minDate ? minDate : new Date();
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	getName() {
		return this.vm.businessUserWorker ? this.vm.businessUserWorker.firstName + ' ' + this.vm.businessUserWorker.lastName : '';
	}
	
	submit() {
		this.vm.processing = true;
		var originalTerminationDate: any = this.angularHelperService.copy(this.vm.wallet.validTo);
		this.vm.newTerminationDate = moment(this.vm.newTerminationDate).startOf("day").utcOffset(0, true).toDate();
		this.vm.wallet.validTo = this.vm.newTerminationDate;
		this.vm.wallet.user = this.vm.businessUserWorker.worker.employee;
		this.restService.saveBusinessClientPolicyUserTerminate({ policyId: this.vm.policy.id }, this.vm.wallet)
			.then((response) => {
				this.vm.wallet.validTo = this.vm.newTerminationDate;
				this.vm.wallet.deactivated = true;
				this.dialogRef.close(response);
			})
			.catch((error) => {
				this.vm.wallet.validTo = originalTerminationDate;
				console.log(error);
				this.vm.processing = false;
			});
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}